/**
 * @desc 更新采购调价申请单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/updateprocurementOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
